import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { Icon } from 'components';

// Styles
import style from './styles.pcss';

const cx = classNames.bind(style);

const DropdownToggle = ({
  onClick, isOpen, isModal, option, isDayToggle,
}) => (
  <button
    className={cx('toggle', { open: !!isOpen, arrow: !isDayToggle || !!isModal })}
    onClick={onClick}
    type="button"
  >
    {isDayToggle && !isModal
      ? (
        <>
          {option && (
          <Text
            color="scarlet"
            size="size3-m"
          >
            {option}
          </Text>
          )}
        </>
      ) : <Icon name="dropdownArrow" />}
  </button>
);

DropdownToggle.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  isModal: PropTypes.bool,
  onClick: PropTypes.func,
  isDayToggle: PropTypes.bool,
};

export { DropdownToggle };
